<template>
  <div id="app-root" :style="rootStyle">
    <router-view />
    <div v-if="isLocked" class="lock-overlay">
      <div class="lock-panel">
        <div class="lock-panel-title">屏幕已锁定</div>
        <div class="lock-panel-user">{{ adminName }}</div>
        <div class="lock-panel-tip">请输入锁屏密码以继续使用系统</div>
        <el-input
          v-model="unlockPassword"
          type="password"
          show-password
          placeholder="请输入锁屏密码"
          @keyup.enter.native="handleUnlock"
        />
        <div class="lock-panel-actions">
          <el-button type="primary" @click="handleUnlock">解锁</el-button>
          <el-button @click="handleLogout">退出登录</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      unlockPassword: ''
    }
  },
  computed: {
    isLocked() {
      return this.$store.getters.isLocked
    },
    adminName() {
      return this.$store.getters.adminName
    },
    layoutSettings() {
      return this.$store.getters.layoutSettings
    },
    rootStyle() {
      return {
        '--theme-color': this.layoutSettings.themeColor || '#409EFF'
      }
    }
  },
  watch: {
    '$route.fullPath': {
      immediate: true,
      handler() {
        this.updateTitle()
      }
    },
    layoutSettings: {
      deep: true,
      handler() {
        this.updateTitle()
      }
    }
  },
  methods: {
    handleUnlock() {
      const success = this.$store.dispatch('unlockScreen', this.unlockPassword)
      Promise.resolve(success).then(result => {
        if (result) {
          this.unlockPassword = ''
          this.$message.success('已解锁')
        } else {
          this.$message.error('锁屏密码错误')
        }
      })
    },
    handleLogout() {
      this.$store.dispatch('logout')
      this.unlockPassword = ''
      this.$router.replace('/login')
    },
    updateTitle() {
      const routeTitle = (this.$route.meta && this.$route.meta.title) || '平台管理端'
      if (this.layoutSettings.dynamicTitle) {
        document.title = `${routeTitle} - 触点z7`
      } else {
        document.title = '触点z7'
      }
    }
  }
}
</script>

<style scoped>
.lock-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: rgba(15, 23, 42, 0.72);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
}

.lock-panel {
  width: 420px;
  padding: 32px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.22);
}

.lock-panel-title {
  font-size: 24px;
  font-weight: 700;
  color: #303133;
}

.lock-panel-user {
  margin-top: 10px;
  font-size: 16px;
  color: #606266;
}

.lock-panel-tip {
  margin: 18px 0 20px;
  color: #909399;
}

.lock-panel-actions {
  margin-top: 18px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}
</style>
